import { render, staticRenderFns } from "./OrganizationTab.vue?vue&type=template&id=7d9baca4"
import script from "./OrganizationTab.vue?vue&type=script&lang=js"
export * from "./OrganizationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports